import { render, staticRenderFns } from "./WelcomePage.vue?vue&type=template&id=29a55cea"
import script from "./WelcomePage.vue?vue&type=script&lang=js"
export * from "./WelcomePage.vue?vue&type=script&lang=js"
import style0 from "./WelcomePage.vue?vue&type=style&index=0&id=29a55cea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports